import React from "react";

function InactiveReview(){
  return(
    <div className="verify-state-box">
							<div className="verify-state-inner">
								<div className="verify-state-icon"><span></span><span></span><span></span></div>
								<p>Under Review</p>
								
							</div>
						</div>
  )
}
export default InactiveReview;